import styled from 'styled-components'

import { Link } from '@subaio/components'

import { helpers } from 'styles'

export const Item = styled(Link)`
	display: grid;
	column-gap: 4px;
	grid-template-columns: 50px 1fr;

	&:hover {
		color: ${helpers.color.link};
	}
`
